import React from 'react'
import './subSuporte.scss'
import { MdComputer } from "react-icons/md";
import { FaConciergeBell } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

export default function SubMenuSuporte() {
  const { t } = useTranslation()
  return (
    <div className="container-submenuSuporte">
      <div className="submenu-Suporte">
        <div className="selfservice">
          <div className="title-self">
            <h1><MdComputer /> Self Service Bra</h1>
          </div>
          <p style={{ color: "#00000052" }}>
            <a href="/SupportTickets">
              {t("navbar.suport.options.ticket_text")}
            </a>
          </p>
          {/* <p style={{ color: "#00000052" }}>
            {t("navbar.suport.options.faq_text")}
          </p> */}

          <p style={{ color: "#00000052" }}>
            <a href="/Chatbot">{t("navbar.suport.options.chat_text")}</a>
          </p>
          <p style={{ color: "#00000052" }}>
            <a href="/DevelopAndIntegrate">{t("navbar.suport.options.integrations_text")}</a>
          </p>
        </div>
      </div>
    </div>
  )
}
